import { styled } from '@mui/system';
import { colorPalette } from '../../../colorPalette';
export const Container = styled('div')(({ flex, size }) => (Object.assign({ textAlign: 'center' }, (size !== 'L'
    ? {
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
    }
    : { flex }))));
export const AdvantageContainer = styled('div')(({ size, isWrap }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ display: 'flex', flexDirection: size !== 'L' ? 'row' : 'column' }, (size === 'L' && { justifyContent: 'center' })), { alignItems: 'center', padding: size === 'L' ? '16px' : '11px 16px', gap: '4px' }), (size !== 'S' && { background: colorPalette.gray100 })), { borderRadius: '8px', flex: 1, width: '100%' }), (isWrap && { flexWrap: 'wrap' }))));
export const HeaderContainer = styled('div')(({ size }) => (Object.assign({ flexDirection: 'row', display: 'flex', alignItems: 'center', gap: '8px' }, (size !== 'L' && { paddingLeft: '5px' }))));
export const ValueContainer = styled('div')(() => ({
    flexDirection: 'row',
    display: 'flex',
}));
export const ClubRPayContainer = styled('div')(({ size }) => ({
    backgroundColor: size === 'M' ? colorPalette.white : colorPalette.gray100,
    borderRadius: 10,
    display: 'flex',
    padding: '4px 8px',
    marginLeft: 4,
    alignItems: 'center',
    justifyContent: 'center',
}));
